import React, { useState, Fragment } from 'react';
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap';

import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import { Colxx } from '../../../../../components/common/CustomBootstrap';

import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { postAPI_Update_Restrictions } from '../../../../../constants/APIs';
import { gAPI_RatesPlan_List_ByRoomId } from '../../../../../constants/APIs';

// Redux
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

function RestrictionsEditModal({
  isVisible,
  toggleModal,
  propertyId,
  roomlist,
  ratelist,
}) {
  //console.log('ratelist', ratelist);
  const templateInputField = {
    roomTypeId: '',
    ratePlanId: '',
    startDate: '',
    endDate: '',
    maximumLengthOfStay: 0,
    minimumLengthOfStay: 0,
    stopSell: false,
    closedArrival: false,
    closedDeparture: false,
  };

  const [inputFields, setInputFields] = useState([templateInputField]);
  const [ratePlanlist, setRatePlanlist] = useState([]);
  const handleAddFields = () => {
    const values = [...inputFields];
    values.push(templateInputField);
    setInputFields(values);
  };

  const handleRemoveFields = index => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    switch (event.target.name) {
      case 'roomTypeId':
        values[index].roomTypeId = event.target.value;
        AxiosAPI({
          methed: 'get',
          url: `${gAPI_RatesPlan_List_ByRoomId}?roomId=${event.target.value}&status=1`,
        })
          .then(res => {
            const ratelist = res.data.ratePlans.map(elem => ({
              ratePlanId: elem.id,
              ratePlanName: elem.name,
            }));
            setRatePlanlist(ratelist);
          })
          .catch(err => {
            console.log(err);
          });
        break;
      case 'ratePlanId':
        values[index].ratePlanId = event.target.value;
        break;
      case 'startDate':
        values[index].startDate = event.target.value;
        break;
      case 'endDate':
        values[index].endDate = event.target.value;
        break;
      case 'maximumLengthOfStay':
        values[index].maximumLengthOfStay = event.target.value;
        break;
      case 'minimumLengthOfStay':
        values[index].minimumLengthOfStay = event.target.value;
        break;
      case 'stopSell':
        values[index].stopSell = event.target.value;
        break;
      case 'closedArrival':
        values[index].closedArrival = event.target.value;
        break;
      case 'closedDeparture':
        values[index].closedDeparture = event.target.value;
        break;

      default:
        break;
    }

    setInputFields(values);
  };

  const handleUpdate = () => {
    AxiosAPI({
      url: postAPI_Update_Restrictions,
      method: 'post',
      data: {
        propertyId,
        data: inputFields,
      },
    }).then(
      setTimeout(() => {
        window.location.reload();
      }, 500)
    );
  };

  return (
    <div>
      <Modal size="lg" isOpen={isVisible} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Edit Restrictions</ModalHeader>
        <AvForm onSubmit={handleUpdate}>
          <ModalBody>
            <AvGroup row>
              {inputFields.map((inputField, index) => (
                <Fragment key={`${inputField}~${index}`}>
                  <Row>
                    <Colxx sm={3}>
                      <AvGroup>
                        <Label>Room Type</Label>
                        <AvInput
                          required
                          name="roomTypeId"
                          type="select"
                          value={inputField.roomTypeId}
                          onChange={event => handleInputChange(index, event)}
                        >
                          <option value="" disabled hidden>
                            Room Type
                          </option>
                          {roomlist.map((elem, index) => (
                            <option value={elem.roomTypeId} key={index}>
                              {elem.roomName}
                            </option>
                          ))}
                        </AvInput>
                        {/* <AvFeedback>Choose the room type!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={3}>
                      <AvGroup>
                        <Label>Rate Plan</Label>
                        <AvInput
                          required
                          name="ratePlanId"
                          type="select"
                          value={inputField.ratePlanId}
                          onChange={event => handleInputChange(index, event)}
                        >
                          <option value="" disabled hidden>
                            Rate Plan
                          </option>
                          {ratePlanlist.map((elem, index) => (
                            <option value={elem.ratePlanId} key={index}>
                              {elem.ratePlanName}
                            </option>
                          ))}
                        </AvInput>
                        {/* <AvFeedback>Choose the room type!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={3}>
                      <AvGroup>
                        <Label>Start Date</Label>
                        <AvInput
                          required
                          type="date"
                          name="startDate"
                          value={inputField.startDate}
                          onChange={event => handleInputChange(index, event)}
                        />
                        {/* <AvFeedback>Choose the start date!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={3}>
                      <AvGroup>
                        <Label>End Date</Label>
                        <AvInput
                          required
                          type="date"
                          name="endDate"
                          value={inputField.endDate}
                          onChange={event => handleInputChange(index, event)}
                        />
                        {/* <AvFeedback>Choose the end date!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={2}>
                      <AvGroup>
                        <Label>Max Stay</Label>
                        <AvInput
                          required
                          name="maximumLengthOfStay"
                          type="number"
                          min={0}
                          onChange={event => handleInputChange(index, event)}
                          value={inputField.maximumLengthOfStay}
                        />
                        {/* <AvFeedback>Set the inventory number!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={2}>
                      <AvGroup>
                        <Label>Min Stay</Label>
                        <AvInput
                          required
                          name="minimumLengthOfStay"
                          type="number"
                          min={0}
                          onChange={event => handleInputChange(index, event)}
                          value={inputField.minimumLengthOfStay}
                        />
                        {/* <AvFeedback>Set the inventory number!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={2}>
                      <AvGroup>
                        <Label>Stop Sell?</Label>
                        <AvInput
                          required
                          name="stopSell"
                          type="select"
                          onChange={event => handleInputChange(index, event)}
                          value={inputField.stopSell}
                        >
                          <option value={false}>No</option>
                          <option value={true}>Yes</option>
                        </AvInput>
                        {/* <AvFeedback>Set the inventory number!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={3}>
                      <AvGroup>
                        <Label>Closed for Arrival?</Label>
                        <AvInput
                          required
                          name="closedArrival"
                          type="select"
                          onChange={event => handleInputChange(index, event)}
                          value={inputField.closedArrival}
                        >
                          <option value={false}>No</option>
                          <option value={true}>Yes</option>
                        </AvInput>
                        {/* <AvFeedback>Set the inventory number!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={3}>
                      <AvGroup>
                        <Label>Closed for Departure?</Label>
                        <AvInput
                          required
                          name="closedDeparture"
                          type="select"
                          onChange={event => handleInputChange(index, event)}
                          value={inputField.closedDeparture}
                        >
                          <option value={false}>No</option>
                          <option value={true}>Yes</option>
                        </AvInput>
                        {/* <AvFeedback>Set the inventory number!</AvFeedback> */}
                      </AvGroup>
                    </Colxx>
                    <Colxx sm={4} className="mb-3">
                      <div>
                        <Button
                          style={{ margin: '6px' }}
                          onClick={handleAddFields}
                          color="primary"
                          size="xs"
                          outline
                        >
                          + Add More
                        </Button>
                        {inputFields.length > 1 && (
                          <Button
                            style={{ margin: '6px' }}
                            onClick={() => handleRemoveFields(index)}
                            color="secondary"
                            size="xs"
                            outline
                          >
                            -
                          </Button>
                        )}
                      </div>
                    </Colxx>
                  </Row>
                </Fragment>
              ))}
            </AvGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              Update
            </Button>
            <Button color="secondary" onClick={toggleModal}>
              Cancel
            </Button>
          </ModalFooter>
        </AvForm>
      </Modal>
    </div>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(RestrictionsEditModal));
